// extracted by mini-css-extract-plugin
export var rateTable = "_4c-0";